.profile {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.profile .betDetails {
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-2);
}
.profile .titleCell {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
}
.profile .titleCell .titleHeading {
  color: var(--cxy-color-content-default);
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-bold);
  line-height: var(--cxy-lineHeight-xxs);
}
.profile .titleCell .titleText {
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-bold);
  line-height: var(--cxy-lineHeight-m);
}
